import * as React from "react";
import {withRouter} from "react-router-dom";
import Link from "gatsby-link";
import navigateTo from "../utils/navigate_to";
import Popover, {PopoverAnimationVertical} from "material-ui/Popover";
import Divider from "material-ui/Divider";
import CircularProgress from "material-ui/CircularProgress";
import {Menu, MenuItem} from "material-ui/Menu";
import * as Media from "react-media";
import OnClient from "../components/OnClient";
import * as ReactRedux from "react-redux";

import Logo from "./Logo";
import WithCurrentUser from "./WithCurrentUser";
import DocSearch from "./DocSearch";
import {cdnAuthedUrl} from "../common";
import {RouteComponentProps} from "react-router";
import SearchIcon from "material-ui/svg-icons/action/search";
import {compose} from 'redux'

import { selectors as docPageSelectors, actions as docPageActions } from "../reducers/doc_page";

const DEFAULT_USER_AVATAR = require("../res/avatar_default.png");

import './Header.scss';
import NavItem from './NavItem'

interface UserAvatarProps {
	avatarURL: string;
	fullName: string;
	logout: () => void;
}

class UserAvatar extends React.Component<UserAvatarProps, any> {
	state = {
		isPopoverOpen: false,
		isMenuActive: false
	};

	private avatarImageEl: HTMLElement;

	handleRequestPopoverClose() {
		this.setState({isPopoverOpen: false});
	}

	handleRequestPopoverOpen() {
		this.setState({isPopoverOpen: true});
	}

	goToPageFromPopover(url: string) {
		this.handleRequestPopoverClose();
		navigateTo(url);
	}

	render() {
		return (
			<>
			<img
				ref={el => (this.avatarImageEl = el)}
				src={cdnAuthedUrl(this.props.avatarURL) || DEFAULT_USER_AVATAR}
				style={{
						width: 40,
						height: 40,
						clipPath: "circle(20px)",
						marginBottom: 0,
						cursor: "pointer",
						borderTopLeftRadius: 20,
						borderTopRightRadius: 20,
						borderBottomRightRadius: 20,
						borderBottomLeftRadius: 20,
					}}
				onClick={this.handleRequestPopoverOpen.bind(this)}
			/>

			<Popover
				open={this.state.isPopoverOpen}
				anchorEl={this.avatarImageEl}
				anchorOrigin={{
						horizontal: "middle",
						vertical: "bottom",
					}}
				targetOrigin={{
						horizontal: "middle",
						vertical: "top",
					}}
				onRequestClose={this.handleRequestPopoverClose.bind(this)}
				style={{
						marginTop: 7,
					}}
				animation={PopoverAnimationVertical}
			>
				<Menu style={{ width: 175 }}>
					<MenuItem primaryText={this.props.fullName} disabled={true}/>
					<MenuItem
						primaryText="Profile"
						onClick={this.goToPageFromPopover.bind(this, "/user")}
					/>
					<MenuItem
						primaryText="Identity Tokens"
						onClick={this.goToPageFromPopover.bind(this, "/user/tokens")}
					/>
					<Divider />
					<MenuItem primaryText="Logout" onClick={this.props.logout}/>
				</Menu>
			</Popover>
			</>
		);
	}
}

interface UserInfoProps {
	user: any;
	userFetchStatus: string;

	logout: () => void;
}

/**
 * displays the user's basic info in the top corner of the header
 */
const UserInfo = (props: UserInfoProps) => {
	if (props.userFetchStatus === "pending") {
		return <CircularProgress />;
	}

	if (props.user && !props.user.isActive) {
		//props.logout();
	}

	if (props.user === undefined || !props.user.isActive) {
		return (
			<>
			<Link
				to="/login"
				style={{
					fontFamily: "Inter RG, sans-serif",
					fontSize: "13px",
					color: "#FFFFFF",
					padding: "10px 20px",
					borderRadius: "3px",
					backgroundColor: "#FC500E",
					letterSpacing: "-0.01px",
					lineHeight: "18px",
					// textTransform: "uppercase",
				}}
			>
				Log in
			</Link>
			</>
		);
	}

	return (
		<UserAvatar
			avatarURL={props.user.avatarURL}
			fullName={`${props.user.firstName}  ${props.user.lastName}`}
			logout={props.logout}
		/>
	);
};

interface HeaderProps extends RouteComponentProps<{}> {
	locationPath: any;
	data: any;

	isDrawerOpen: boolean;
	openDrawer(): any;
	closeDrawer(): any;
}



/**
 * top of page header
 */
class Header extends React.Component<HeaderProps, any> {
	state = {
		isSearchOpen: false,
		isPopoverOpen: false,
		isBentoMenuActive: false,
		isMenuActive: false,
	};

	private labelElem: HTMLElement;

	handleRequestPopoverClose = () => {
		this.setState({isPopoverOpen: false});
	};

	handleRequestPopoverOpen = () => {
		this.setState({isPopoverOpen: true});
	};

	goToPageFromPopover = (url: string) => {
		this.handleRequestPopoverClose();
		navigateTo(url);
	};

	handleBentoMenuActive = () => {
		this.setState({isBentoMenuActive: !this.state.isBentoMenuActive});
		this.setState({isSearchOpen: false});
	};

	handleMenuActive = () => {
		this.setState({isMenuActive: !this.state.isMenuActive});
	};

	render() {
		const {isSearchOpen} = this.state;

		return (
			<Media query={{ maxWidth: 1024 }}>
				{isMobile => (
					<OnClient>
						{hasRendered => (
							<>
							{hasRendered && (
								<div
									style={{
											display: "flex",
											flexDirection: "column",
											position: "fixed",
											top: 0,
											left: 0,
											right: 0,
											zIndex: 3, // cover up the hamburger menu when the search is open
											width: "100%",
											boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.1)'
										}}
								>
									<div
										style={{
												padding: "16px 30px",
												display: "flex",
												flexDirection: "row",
												backgroundColor: "white",
												alignItems: "center"
											}}
									>

										<Link to="/" style={{ display: "flex", placeItems: "center", flexShrink: 0}}>
											<Logo
												isHeader={true}
												style={{
													height: "34px",
													marginBottom: 0,
													cursor: "pointer",
												}}
											/>
											<span
											style={{
												color: '#000000',
												fontSize: '16px',
												marginLeft: '10px',
												fontFamily: 'Outfit SB',
												letterSpacing: '2px'
											}}
											>DEVELOPER PORTAL</span>
										</Link>

										{!isMobile && (
											<div
												style={{
													display: "flex",
													flexDirection: "row",
													flexShrink: 0,
													alignItems: "center",
													marginLeft: "48px",
												}}
											>

												{/* <NavItem
													link="/api/general/introduction"
													activePrefix="/api"
													title="API REFERENCE"
												/> */}

												<NavItem
													link="/documentation/general/home"
													activePrefix="/documentation"
													title="DOCUMENTATION"
													onClick={() => {}}
												/>

												{/* <NavItem link="/sdks" activePrefix="/sdks" title="SDKS"/> */}

												<NavItem link='' href="https://feedback.vatom.com/changelog?labels=developer-portal" activePrefix="/" title="Change Log" onClick={() => {}}/>

												<NavItem link='' href="https://support.vatom.com/hc/en-us/community/topics/8138075849371-Developers" activePrefix="/" title="Forum" onClick={() => {}}/>
											</div>
										)}

										<div
											style={{
												display: "flex",
												flexDirection: "row",
												alignItems: "center",
												width: "100%",
												maxWidth: "360px",
												marginLeft: "auto"
											}}
										>
											<DocSearch
												style={{
														fontSize: 20,
														boxSizing: "border-box",
														backgroundColor: "white",
														justifyContent: "flex-end",
														alignItems: "center",
													}}
												onFocus={() => {
														this.setState({ isSearchOpen: true });
													}}
												onBlur={() => {
														this.setState({ isSearchOpen: false });
													}}
												isInFocus={isSearchOpen}
												data={this.props.data}
											/>
										</div> 
									{!isMobile ? 
										<div 
											style={{
												position: 'relative', 
												flexShrink: 0,
												marginLeft: isMobile ? "auto" : "5px",
											}}
										>
											<span 
												className={`bento-menu-button circle-button hover ${this.state.isBentoMenuActive ? 'active' : ''}`} 
												onClick={() => this.handleBentoMenuActive()}
											>
												<img src={require('../res/header-icons/bento-menu-icon.svg')}/>
											</span>
											<div className="app-menu bento-menu">
												<ul className="drop-down">
													<li>
														<a href="https://market.vatom.com/" title="Market" target="_blank">
															<span className="svg-holder">
																<img src={require('../res/header-icons/market-icon.svg')}/>
															</span>
															<span>Market</span>
														</a>
													</li>
													<li><a href="https://www.spatialweb.net/" target="_blank" title="Spaces">
														<span className="svg-holder">
															<img src={require('../res/header-icons/spaces-icon.svg')}/>
														</span>
														<span>Spaces</span></a>
													</li>
													<li><a href="https://studio.vatominc.com/" target="_blank" title="Studio">
														<span className="svg-holder">
															<img src={require('../res/header-icons/studio-icon.svg')}/>
														</span>
														<span>Studio</span></a>
													</li>
													<li><a href="https://wallet.vatom.com/" target="_blank" title="Wallet">
														<span className="svg-holder wallet">
															<img src={require('../res/header-icons/wallet-icon.svg')}/>
														</span>
														<span>Wallet</span></a>
													</li>
												</ul>
											</div>
										</div> : 
										<>
										<span className="search-icon"
											onClick={() => document.querySelector('.general-search').style.display = "flex"}
										>
											<i className="far fa-search" />
										</span>
										<button 
											className={`hamburger ${this.props.isDrawerOpen ? 'active' : ''}`} 
											type="button" 
											onClick={() => {
												if (this.props.isDrawerOpen) {
													this.props.closeDrawer()
													document.body.style.overflow = "initial"
												} else {
													this.props.openDrawer()
													document.body.style.overflow = "hidden"
												}
											}}
										>
											<span></span>
											<span></span>
											<span></span>
										</button>
										</>
									}

									</div>

									{/* {isMobile && <MobileNavigator 
										isActive={this.state.isMenuActive} 
										isSearchOpen={isSearchOpen}
										onFocus={() => {
											this.setState({ isSearchOpen: true });
										}}
										onBlur={() => {
											this.setState({ isSearchOpen: false });
										}}
										onNavClick={() => this.handleMenuActive()}
										data={this.props.data}
										/>
									} */}
								</div>
							)}
							</>
						)}
					</OnClient>
				)}
			</Media>
		);
	}
}

interface MobileNavigatorProps {
	isActive: boolean;
	isSearchOpen: boolean;
	onFocus(): void;
	onBlur(): void;
	onNavClick(): void;
	data: any;
}

class MobileNavigator extends React.Component<MobileNavigatorProps, any> {
	private scrollElement: HTMLElement;

	componentDidMount() {
		// shift the scroller to the left slightly to cut off first link - makes it obvious its scrollable
		this.scrollElement.scrollLeft = 50;
	}

	render() {
		return (
			<div
				style={{
					display: "flex",
					justifyContent: "center",
					position: "fixed",
					bottom: 0,
					width: "100%",
					height: "calc(100% - 66px)",
					padding: 40,
					backgroundColor: "white",
					transform: this.props.isActive ? "translateX(0%)" : "translateX(-100%)",
					transition: "all .2s",
				}}
			>
				<div
					ref={el => (this.scrollElement = el)}
					style={{
						display: "flex",
						flexDirection: "column",
						width: "100%",
					}}
				>

					<DocSearch
						style={{
							display: process.env.FEATURE_SEARCH_ENABLED === "true" ? "flex" : "none",
							justifyContent: "flex-end",
							alignItems: "center",
							marginBottom: "40px",
							fontSize: 20,
							boxSizing: "border-box",
							backgroundColor: "white",
						}}
						onFocus={() => this.props.onFocus()}
						onBlur={() => this.props.onBlur()}
						isInFocus={this.props.isSearchOpen}
						data={this.props.data}
					/>

					{/* <NavItem
						link="/api/general/introduction"
						activePrefix="/api"
						title="API REFERENCE"
						style={{fontSize: "20px", margin: "20px 0" }}
					/> */}

					<NavItem
						link="/documentation/general/home"
						activePrefix="/documentation"
						title="DOCUMENTATION"
						style={{fontSize: "20px", margin: "20px 0" }}
						onClick={() => this.props.onNavClick()}
					/>

					<NavItem 
						link='' 
						href="https://feedback.vatom.com/changelog?labels=developer-portal" 
						activePrefix="/" 
						title="Change Log" 
						style={{fontSize: "20px", margin: "20px 0" }} 
						onClick={() => {}}
					/>

					<NavItem 
						link='' 
						href="https://support.vatom.com/hc/en-us/community/topics/8138075849371-Developers" 
						activePrefix="/" 
						title="Forum" 
						style={{fontSize: "20px", margin: "20px 0" }} 
						onClick={() => {}}
					/>

				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	isDrawerOpen: docPageSelectors.isDrawerOpen(state),
});

const mapDispatchToProps = {
	openDrawer: docPageActions.openDrawer,
	closeDrawer: docPageActions.closeDrawer,
};

export default  compose(
	withRouter,
	ReactRedux.connect(mapStateToProps,mapDispatchToProps)
)(Header);


// WEBPACK FOOTER //
// ./src/components/Header.tsx